/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

const __initWithSharedSwiper = () => {
  const { Swiper, A11y, Autoplay, EffectFade, Keyboard, Mousewheel, Navigation, Pagination, Scrollbar } = window.T3SwiperRuntime || {};
  if (!Swiper) return;
;// ./src/javascripts/webcomponents/product-card.js



class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.swiperEl = this.querySelector('.card-color-swatch--wrapper.swiper');
    this.swiperContainer = this.querySelector('.card-color-swatch--wrapper .swiper-wrapper');
    this.colorSwatches = this.querySelectorAll('.card-color-swatch--inner');
    this.otherSwatches = this.querySelectorAll('product-swatch input[type="radio"]');
    this.productCardColorName = this.querySelector('[data-product-card-swatch-color-name]');
    this.salePriceContainer = this.querySelector('.product-price--sale');
    this.regularPriceContainer = this.querySelector('.product-price--regular');
    this.swatchImage = this.querySelector('[data-product-card-swatch-image]');
    this.secondaryVideos = this.querySelectorAll('.product-card__image--secondary.video');

    // Cache the global translation payload once so every card reuses the same object.
    if (!this.constructor.globalTranslations) {
      const globalEl = document.querySelector('script#wetheme-global');
      if (globalEl) {
        try {
          const parsedGlobals = JSON.parse(globalEl.textContent);
          this.constructor.globalTranslations = parsedGlobals?.translations || {};
        } catch (error) {
          this.constructor.globalTranslations = {};
        }
      } else {
        this.constructor.globalTranslations = {};
      }
    }

    // Store a per-instance pointer for convenient translation lookups.
    this.translations = this.constructor.globalTranslations || {};

    this.handleClickBound = this.handleClick.bind(this);
    this.handleMouseOverBound = this.handleMouseOver.bind(this);
    this.handleMouseOutBound = this.handleMouseOut.bind(this);
    this.handleResizeBound = this.handleResize.bind(this);
    this.reinitSwatchesBound = this.reinitSwatches.bind(this);
    this.handleCardMouseEnterBound = this.playSecondaryVideos.bind(this);
    this.handleCardMouseLeaveBound = this.pauseSecondaryVideos.bind(this);

    this.disableSwiperBtnBound = this.disableSwiperBtn.bind(this);
    this.enableSwiperBtnBound = this.enableSwiperBtn.bind(this);

    this.variantsData = { variants: [] };
    this.colorOptionName = this.detectColorOptionName();
  }

  connectedCallback() {
    this.setupSecondaryVideos();
    this.initSwatches();

    // Listen for section load
    document.addEventListener('theme:section:load', this.reinitSwatchesBound);
    document.addEventListener('shopify:section:load', this.reinitSwatchesBound);
  }

  initSwatches() {
    this.colorSwatches = this.querySelectorAll('.card-color-swatch--inner');
    this.otherSwatches = this.querySelectorAll('product-swatch input[type="radio"]');
    this.variantsData = this.loadVariantsData();
    const detectedOptionName = this.detectColorOptionName();
    if (detectedOptionName) this.colorOptionName = detectedOptionName;

    // Prep placeholder image
    this.setupPlacholderImage();

    // Set the default variant
    this.setVariantDefaults();

    // Calculate slides per view
    this.getSlidesPerView();

    // Initialize the slider
    if (this.swiperEl) this.initSwiper();

    // After slider init
    this.afterSliderInit();

    // Set up the event listeners
    this.setEventListeners();
  }

  initSwiper() {
    const nextEl = this.querySelector('.swatch-swiper-button--next');
    this.swiper = new Swiper(this.swiperEl, {
      modules: [A11y, Navigation, Mousewheel],
      slidesPerView: this.slidesPerView,
      slidesPerGroup: this.slidesPerView - 1,
      navigation: {
        nextEl
      },
      spaceBetween: 10,
      loop: false,
      watchOverflow: true,
      allowTouchMove: true,
      mousewheel: {
        invert: false,
      },
    });
  }

  setVariantDefaults() {
    const activeSwatch = this.querySelector('.card-color-swatch--inner.active');
    if (!activeSwatch) return;

    const variantData = activeSwatch.dataset.variant;
    const variant = variantData ? JSON.parse(variantData) : '';
    // Treat forced OOS swatches the same as genuinely unavailable variants.
    const forceOutOfStock = activeSwatch.dataset.forceOutOfStock === 'true';
    if (variant && forceOutOfStock) {
      variant.available = false;
      variant.force_out_of_stock = true;
    }
    variant.listingImage = activeSwatch.dataset.variantListingImage;
    const cardLinks = this.querySelectorAll('[data-product-card-link]');
    
    // Update the card image
    this.setImageDimensions(this.swatchImage);
    this.updateCardImage(variant);

    // Update card links
    cardLinks.forEach((link) => {
      const linkHref = link.getAttribute('href');
      this.updateCardLinks(link, linkHref, variant);
    });

    // Update the price
    this.updateCardPrice(activeSwatch);

    // Ensure every quick-add form inside the card mirrors the current variant availability.
    this.querySelectorAll('.quick-add-wrapper form').forEach((form) => {
      this.updateQuickAddButtonState(form, variant);
    });

    this.refreshSwatchAvailability();
  }

  setEventListeners() {
    this.colorSwatches.forEach((swatch) => {
      swatch.addEventListener('mouseover', this.handleMouseOverBound);
      swatch.addEventListener('click', this.handleClickBound);
    });

    this.otherSwatches.forEach((swatch) => {
      swatch.addEventListener('change', this.handleClickBound);
    });

    // Handle mouse out of the swiper container
    if (this.isNotASlider) {
      if (this.swiperContainer) this.swiperContainer.addEventListener('mouseleave', this.handleMouseOutBound);
    } else {
      if (this.swiperEl) this.swiperEl.addEventListener('mouseleave', this.handleMouseOutBound);
    }

    // Handle window resize
    window.addEventListener('resize', this.handleResizeBound);
  }

  setupSecondaryVideos() {
    this.secondaryVideos = this.querySelectorAll('.product-card__image--secondary.video');
    if (!this.secondaryVideos.length) return;

    this.secondaryVideos.forEach((video) => {
      video.preload = 'none';
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.pause();
    });

    this.addEventListener('mouseenter', this.handleCardMouseEnterBound);
    this.addEventListener('mouseleave', this.handleCardMouseLeaveBound);
  }

  shouldPlaySecondaryVideos() {
    return !window.matchMedia || window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  playSecondaryVideos() {
    if (!this.shouldPlaySecondaryVideos()) return;

    this.secondaryVideos.forEach((video) => {
      const playPromise = video.play();
      if (playPromise?.catch) {
        playPromise.catch(() => {});
      }
    });
  }

  pauseSecondaryVideos() {
    this.secondaryVideos.forEach((video) => {
      video.pause();
    });
  }

  removeEventListeners() {
    this.colorSwatches.forEach((swatch) => {
      swatch.removeEventListener('mouseover', this.handleMouseOverBound);
      swatch.removeEventListener('click', this.handleClickBound);
    });

    // Remove mouse out of the swiper container
    if (this.isNotASlider) {
      if (this.swiperContainer) this.swiperContainer.removeEventListener('mouseleave', this.handleMouseOutBound);
    } else {
      if (this.swiperEl) this.swiperEl.removeEventListener('mouseleave', this.handleMouseOutBound);
    }

    // Remove window resize event listener
    window.removeEventListener('resize', this.handleResizeBound);
    this.removeEventListener('mouseenter', this.handleCardMouseEnterBound);
    this.removeEventListener('mouseleave', this.handleCardMouseLeaveBound);

    // Remove section load event listener
    document.removeEventListener('theme:section:load', this.reinitSwatchesBound);
    document.removeEventListener('shopify:section:load', this.reinitSwatchesBound);
  }

  afterSliderInit() {
    if (!this.swiper) return;
    if (this.swiperEl.classList.contains('swatch-no-slider')) this.swiperEl.classList.remove('swatch-no-slider');

    this.isNotASlider = this.querySelector('.swatch-swiper-button--next.swiper-button-disabled');
    if (this.isNotASlider) this.swiperEl.classList.add('swatch-no-slider');

    if (!this.isNotASlider) {
      this.handleFirstSlideFocus();
      this.handleLastSlideFocus();
    } 
  }

  handleFirstSlideFocus() {
    const firstSlideInGroup = this.querySelector('.swiper-slide:not(.non-focusable)');
    if (!firstSlideInGroup) return;

    const swatchButton = firstSlideInGroup.querySelector('[data-product-card-swatch-button]');
    if (!swatchButton) return;

    swatchButton.addEventListener('focus', this.enableSwiperBtnBound);
  }

  handleLastSlideFocus() {
    const lastSlideInGroup = this.swiper.slides[this.slidesPerView - 1];
    if (!lastSlideInGroup) return;

    const swatchButton = lastSlideInGroup.querySelector('[data-product-card-swatch-button]');
    if (!swatchButton) return;

    swatchButton.addEventListener('focus', this.disableSwiperBtnBound);
  }

  enableSwiperBtn() {
    const nextEl = this.querySelector('.swatch-swiper-button--next');
    if (!nextEl) return;

    const usingKeyboard = document.body.classList.contains('using-keyboard');
    if (usingKeyboard) {
      nextEl.classList.remove('swiper-button-disabled');
      nextEl.setAttribute('tabindex', 0);
    }
  }

  disableSwiperBtn() {
    const nextEl = this.querySelector('.swatch-swiper-button--next');
    if (!nextEl) return;

    const usingKeyboard = document.body.classList.contains('using-keyboard');
    if (usingKeyboard) {
      nextEl.classList.add('swiper-button-disabled');
      nextEl.setAttribute('tabindex', -1);
    }
  }

  handleResize() {
    // Reset image dimensions
    this.setImageDimensions(this.swatchImage);

    // Reinitialize the slider
    if (this.resizeRAF) {
      cancelAnimationFrame(this.resizeRAF);
    }

    this.resizeRAF = requestAnimationFrame(() => {
      this.reinitSlider();
    });
  }

  reinitSwatches() {
    if (this.swiper) this.swiper.destroy();
    this.initSwatches();
  }

  reinitSlider() {
    if (this.swiper) {
      this.swiper.destroy();
      this.getSlidesPerView();
      
      // Reinitialize the slider
      this.initSwiper();
    }
  }

  getSlidesPerView() {
    if (!this.colorSwatches.length) return;
    this.productCardRect = this.getBoundingClientRect();
    this.productCardWidth = this.productCardRect.width;
    this.colorSwatchWidth = this.colorSwatches[0].offsetWidth;

    if (!this.productCardWidth || !this.colorSwatchWidth) return;

    this.swatchGap = 10;
    this.slidesPerViewCount = Math.floor(this.productCardWidth / (this.colorSwatchWidth + this.swatchGap));
    this.slidesPerView = this.slidesPerViewCount;
  }

  handleMouseOver(e) {
    const variantData = e.currentTarget.dataset.variant;
    const variant = variantData ? JSON.parse(variantData) : '';
    // Forced OOS variants should behave exactly like sold-out variants inside the card.
    const forceOutOfStock = e.currentTarget.dataset.forceOutOfStock === 'true';
    if (variant && forceOutOfStock) {
      variant.available = false;
      variant.force_out_of_stock = true;
    }
    variant.listingImage = e.currentTarget.dataset.variantListingImage;

    // Update the color name
    this.updateColorName(e.currentTarget);
    
    // Update the card image
    this.updateCardImage(variant);

    // Update the live region with the image alt
    this.updateLiveRegionWithAlt(e.currentTarget, variant);

    // Update the card price
    this.updateCardPrice(e.currentTarget);

    // Add 'sibling-hover--active' class to the checked radio button
    const activeButton = this.querySelector('[data-product-card-swatch-button].swatch-selected');
    const currentButton = e.currentTarget.querySelector('[data-product-card-swatch-button]');

    if (activeButton) {
      activeButton.classList.add('sibling-hover--active');
      if (currentButton === activeButton) activeButton.classList.remove('sibling-hover--active');
    }
  }

  handleMouseOut(e) {
    const activeSwatch = this.querySelector('.card-color-swatch--inner.active');
    
    if (activeSwatch) {
      const variantData = activeSwatch.dataset.variant;
      const variant = variantData ? JSON.parse(variantData) : '';
      const forceOutOfStock = activeSwatch.dataset.forceOutOfStock === 'true';
      if (variant && forceOutOfStock) {
        variant.available = false;
        variant.force_out_of_stock = true;
      }
      variant.listingImage = e?.currentTarget.dataset.variantListingImage;

      // Update the color name
      this.updateColorName(activeSwatch);
      
      // Update the card image
      this.updateCardImage(variant);

      // Update the live region with the image alt
      this.updateLiveRegionWithAlt(activeSwatch, variant);

      // Update the card price
      this.updateCardPrice(activeSwatch);

      // Remove 'sibling-hover--active' class from the checked radio button
      const activeButton = this.querySelector('[data-product-card-swatch-button].swatch-selected');
      if (activeButton) activeButton.classList.remove('sibling-hover--active');
    }
  }

  handleClick(e) {
    if (e.currentTarget.dataset?.colorValue) {
      this.colorSwatches.forEach((swatch) => swatch.classList.remove('active'));
      e.currentTarget.classList.add('active');
    }

    const activeButton = this.querySelector('[data-product-card-swatch-button].swatch-selected');
    const currentButton = e.currentTarget.querySelector('[data-product-card-swatch-button]');

    const variantData = e.currentTarget.dataset?.variant;
    const variant = variantData ? JSON.parse(variantData) : '';
    const forceOutOfStock = e.currentTarget.dataset.forceOutOfStock === 'true';
    if (variant && forceOutOfStock) {
      variant.available = false;
      variant.force_out_of_stock = true;
    }
    if (variant) {
      variant.listingImage = e.currentTarget.dataset?.variantListingImage;
    }
    const cardLinks = this.querySelectorAll('[data-product-card-link]');

    const selectedOptions = this.collectSelectedOptions();

    // Find the variant that matches the selected options
    const matchingVariant = this.findVariantByOptions(selectedOptions);

    // Prefer the local form for this swatch, but fall back to the first quick-add form if necessary.
    const productForm = e.currentTarget.closest('.color-swatch--block')?.parentElement.querySelector('form') || this.querySelector('.quick-add-wrapper form');
    const idInput = productForm?.querySelector('input[name="id"]');

    if (matchingVariant) {
      if (idInput) idInput.value = matchingVariant.id;
    } else if (idInput && variant?.id) {
      idInput.value = variant.id;
    }

    const effectiveVariant = matchingVariant || variant;
    if (forceOutOfStock && effectiveVariant) {
      effectiveVariant.available = false;
      effectiveVariant.force_out_of_stock = true;
    }

    this.updateQuickAddButtonState(productForm, effectiveVariant);
    this.refreshSwatchAvailability(selectedOptions);

    if (matchingVariant && !e.currentTarget.dataset?.colorValue) {
      return; // Clicking in a size swatch; no further UI updates needed.
    }

    // Set aria attributes
    this.updateLiveRegion(e.currentTarget);

    // Update the active button state
    if (activeButton) activeButton.classList.remove('swatch-selected');
    if (currentButton) currentButton.classList.add('swatch-selected');

    // Update all links with the new variant url
    cardLinks.forEach((link) => {
      const linkHref = link.getAttribute('href');
      this.updateCardLinks(link, linkHref, variant);
    });

    // Update the color name
    this.updateColorName(e.currentTarget);

    // Update the card image
    this.updateCardImage(variant);

    // Update the card price
    this.updateCardPrice(e.currentTarget);
  }

  loadVariantsData() {
    const variantsScript = this.querySelector('script.variants');
    if (!variantsScript) {
      return this.variantsData?.variants?.length ? this.variantsData : { variants: [] };
    }

    try {
      const parsed = JSON.parse(variantsScript.textContent);
      if (parsed?.variants?.length) {
        parsed.variants = parsed.variants.map((variant) => ({
          ...variant,
          available: variant?.available !== false,
          force_out_of_stock: variant?.force_out_of_stock === true
        }));
      }
      return parsed;
    } catch (error) {
      console.warn('Unable to parse product card variants payload', error);
      return { variants: [] };
    }
  }

  detectColorOptionName() {
    const swatchWithOption = this.querySelector('.card-color-swatch--inner[data-option]');
    if (swatchWithOption?.dataset.option) return swatchWithOption.dataset.option;

    const activeSwatch = this.querySelector('.card-color-swatch--inner.active');
    const activeValue = activeSwatch?.dataset.optionValue || activeSwatch?.dataset.colorValue;
    if (!activeValue || !this.variantsData?.variants?.length) return null;

    const candidate = this.variantsData.variants.find((variant) => {
      const optionValues = variant?.options ? Object.values(variant.options) : [];
      return optionValues.includes(activeValue);
    });

    if (!candidate?.options) return null;

    const match = Object.entries(candidate.options).find(([, value]) => value === activeValue);
    return match ? match[0] : null;
  }

  collectSelectedOptions() {
    const selections = {};

    this.querySelectorAll('product-swatch input[type="radio"]:checked').forEach((input) => {
      const swatchElement = input.closest('.swatch-element');
      const optionName = swatchElement?.getAttribute('data-option') || input.getAttribute('data-option');
      const optionValue = input.value || input.getAttribute('data-option-value');
      if (optionName && optionValue) {
        selections[optionName] = optionValue;
      }
    });

    const activeColor = this.querySelector('.card-color-swatch--inner.active');
    if (activeColor) {
      const optionName = activeColor.dataset.option || this.colorOptionName || 'Color';
      const optionValue = activeColor.dataset.optionValue || activeColor.dataset.colorValue;
      if (optionName && optionValue) {
        selections[optionName] = optionValue;
      }
    }

    return selections;
  }

  findVariantByOptions(optionSelection = {}) {
    if (!this.variantsData?.variants?.length) return null;
    const entries = Object.entries(optionSelection);
    if (!entries.length) return null;

    return this.variantsData.variants.find((variant) => {
      if (!variant?.options) return false;
      return entries.every(([key, value]) => {
        if (!key) return true;
        const variantValue = variant.options[key];
        if (typeof variantValue === 'undefined') return false;
        return variantValue === value;
      });
    }) || null;
  }

  refreshSwatchAvailability(baseSelection = null) {
    if (!this.variantsData?.variants?.length) return;

    const selection = baseSelection ? { ...baseSelection } : this.collectSelectedOptions();

    this.updateVariantSwatchAvailability(selection);
    this.updateColorSwatchAvailability(selection);
  }

  updateVariantSwatchAvailability(selection) {
    const swatchElements = this.querySelectorAll('product-swatch .swatch-element[data-option]');
    if (!swatchElements.length) return;

    const soldOutLabel = this.getSoldOutLabel();

    swatchElements.forEach((element) => {
      const optionName = element.getAttribute('data-option');
      const input = element.querySelector('input[type="radio"]');
      if (!optionName || !input) return;

      const optionValue = input.value || input.getAttribute('data-option-value');
      if (!optionValue) return;

      const candidateSelection = { ...selection, [optionName]: optionValue };
      const candidateVariant = this.findVariantByOptions(candidateSelection);
      let forced = false;
      let isAvailable = false;

      if (candidateVariant) {
        forced = candidateVariant.force_out_of_stock === true;
        isAvailable = candidateVariant.available && !forced;
      } else {
        forced = input.getAttribute('data-force-out-of-stock') === 'true';
      }

      element.setAttribute('data-swatch-option-available', String(isAvailable));
      const productSwatchEl = element.closest('product-swatch');
      const isNonColorSwatch = productSwatchEl?.getAttribute('data-is-color-swatch') !== 'true';
      const isAvailableForClass = isNonColorSwatch
        ? this.variantsData.variants.some(v => v.options[optionName] === optionValue && v.available && !v.force_out_of_stock)
        : isAvailable;
      element.classList.toggle('available', isAvailableForClass);
      element.classList.toggle('soldout', !isAvailableForClass);
      input.dataset.forceOutOfStock = String(forced);
      input.setAttribute('data-force-out-of-stock', String(forced));

      if (!isAvailable) {
        input.setAttribute('tabindex', '-1');
      } else {
        input.removeAttribute('tabindex');
      }

      const statusText = element.querySelector('[data-status-text]');
      if (statusText) {
        if (!statusText.dataset.defaultText) {
          statusText.dataset.defaultText = statusText.textContent || '';
        }
        statusText.textContent = isAvailable ? '' : statusText.dataset.defaultText || `(${soldOutLabel})`;
      }
    });
  }

  updateColorSwatchAvailability(selection) {
    if (!this.colorSwatches?.length) return;

    const optionNameFallback = this.colorOptionName || 'Color';

    this.colorSwatches.forEach((swatch) => {
      const optionName = swatch.dataset.option || optionNameFallback;
      const optionValue = swatch.dataset.optionValue || swatch.dataset.colorValue;
      if (!optionName || !optionValue) return;

      const candidateSelection = { ...selection, [optionName]: optionValue };
      const candidateVariant = this.findVariantByOptions(candidateSelection);
      const button = swatch.querySelector('[data-product-card-swatch-button]');
      let forced = false;
      let isAvailable = false;

      if (candidateVariant) {
        forced = candidateVariant.force_out_of_stock === true;
        isAvailable = candidateVariant.available && !forced;
      } else {
        forced = swatch.getAttribute('data-force-out-of-stock') === 'true' || button?.getAttribute('data-force-out-of-stock') === 'true';
      }

      this.applyColorSwatchAvailability(swatch, isAvailable, forced, button);
    });
  }

  applyColorSwatchAvailability(swatch, isAvailable, isForced, buttonReference = null) {
    swatch.dataset.forceOutOfStock = String(isForced);
    swatch.setAttribute('data-force-out-of-stock', String(isForced));
    swatch.classList.toggle('non-focusable', !isAvailable);

    const button = buttonReference || swatch.querySelector('[data-product-card-swatch-button]');
    if (!button) return;

    button.dataset.forceOutOfStock = String(isForced);
    button.setAttribute('data-force-out-of-stock', String(isForced));
    button.classList.toggle('sold-out', !isAvailable);
    if (!isAvailable) {
      button.setAttribute('tabindex', '-1');
    } else {
      button.removeAttribute('tabindex');
    }
  }

  getSoldOutLabel() {
    return this.getTranslation('soldOut', this.translations?.soldOut || 'Sold Out');
  }

  updateLiveRegion(swatch) {
    if (!swatch) return;

    const productId = swatch.dataset.productId;
    const productTitle = swatch.dataset.productTitle;
    const colorName = swatch.dataset.colorValue;
    const colorSelectedString = swatch.dataset.colorSelectedString;
    if (!productId || !productTitle || !colorName || !colorSelectedString) return;

    const liveRegion = this.querySelector(`#aria-swatch-live-region-${productId}`);
    if (!liveRegion) return;

    liveRegion.textContent = `${colorSelectedString} ${productTitle} ${colorName}`;
    liveRegion.tabIndex = -1;
    liveRegion.blur();
  }

  updateLiveRegionWithAlt(swatch, variant) {
    if (!swatch || !variant) return;

    const alt = variant.featured_image?.alt;
    if (!alt) return;

    const productId = swatch.dataset.productId;
    const liveRegion = this.querySelector(`#aria-swatch-live-region-${productId}`);
    if (!liveRegion) return;

    liveRegion.textContent = `${alt}`;
  }

  updateCardLinks(link, url, variant) {
    if (!url || !link) return;

    if (url.includes('?variant=')) {
      const newUrl = url.split('?variant=')[0];
      url = newUrl;
    }

    const activeSwatch = this.querySelector('.card-color-swatch--inner.active');
    if (!activeSwatch) return;

    const variantUrl = activeSwatch.getAttribute('data-variant-url');
  
    if (variant && variantUrl) {
      link.setAttribute('href', variantUrl);
    } else {
      link.setAttribute('href', url);
    }
  } 

  // Convenience helper that mirrors the ProductInformation implementation.
  getTranslation(key, fallback = '') {
    if (!key) return fallback;
    if (this.translations && Object.prototype.hasOwnProperty.call(this.translations, key) && this.translations[key]) {
      return this.translations[key];
    }
    return fallback;
  }

  // Keep the quick-add CTA text and enabled state in sync with the selected variant.
  updateQuickAddButtonState(form, variant) {
    if (!form) return;
    const button = form.querySelector('.quick-add-button');
    if (!button) return;
    if (!button.dataset.originalLabel) {
      button.dataset.originalLabel = button.textContent.trim();
    }

    // When a variant is provided, trust its data directly — don't read stale DOM state.
    const forceOutOfStock = variant != null ? variant.force_out_of_stock === true : this.isCurrentSelectionForcedOutOfStock();
    const isAvailable = variant != null ? (variant.available !== false && !forceOutOfStock) : !forceOutOfStock;
    const defaultKey = button.dataset.addToCartTranslationKey || 'addToCart';
    const defaultLabel = this.getTranslation(defaultKey, button.dataset.originalLabel);
    const soldOutLabel = this.getTranslation('soldOut', this.translations?.soldOut || '{{ "products.product.sold_out" | t }}');

    if (isAvailable) {
      button.textContent = defaultLabel;
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      button.classList.remove('sold-out');
      button.setAttribute('aria-label', defaultLabel);
    } else {
      button.textContent = soldOutLabel;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('sold-out');
      button.setAttribute('aria-label', soldOutLabel);
    }
  }

  isCurrentSelectionForcedOutOfStock() {
    const activeSwatch = this.querySelector('.card-color-swatch--inner.active');
    if (activeSwatch?.dataset.forceOutOfStock === 'true') return true;
    const checkedInput = this.querySelector('product-swatch input[data-product-variant]:checked');
    if (checkedInput?.getAttribute('data-force-out-of-stock') === 'true') return true;
    return false;
  }

  updateColorName(targetEl) {
    if (!targetEl || !this.productCardColorName) return;

    const colorValue = targetEl.dataset.colorValue;
    if (!colorValue) return;

    this.animateColorLabel(colorValue);
    this.productCardColorName.textContent = colorValue;
  }

  animateColorLabel(label) {
    if (label === this.currentLabel) return;

    /* ===== Animate the color label if label has changed ===== */
    this.productCardColorName.classList.remove('fade-in-label-simple');
    void this.productCardColorName.offsetWidth; // Force reflow to reset the animation
    this.productCardColorName.classList.add('fade-in-label-simple');

    /* ===== Keep track of the current label ===== */
    this.currentLabel = label;
  }

  setupPlacholderImage() {
    const productCardSwatchImage = this.querySelector('[data-product-card-swatch-image]');

    if (!productCardSwatchImage) return;

    productCardSwatchImage.removeAttribute('loading');
    productCardSwatchImage.removeAttribute('srcset');
  }

  updateCardImage(variant) {
    const productCardImage = this.querySelector('[data-product-card-image]');
    const productCardSwatchImage = this.querySelector('[data-product-card-swatch-image]');

    if (!productCardImage || !productCardSwatchImage) return;

    productCardSwatchImage.removeAttribute('srcset');

    if (variant && (variant.featured_image || variant.listingImage)) {
      const imgSrc = variant.listingImage || variant.featured_image.src;
      const imgAlt = variant.featured_image.alt;

      productCardSwatchImage.setAttribute('src', imgSrc);
      productCardSwatchImage.setAttribute('alt', imgAlt);
      productCardSwatchImage.style.opacity = 1;
      productCardImage.style.opacity = 0;
    } else {
      productCardSwatchImage.style.opacity = 0;
      productCardImage.style.opacity = 1;
    }
  }

  setImageDimensions(image) {
    if (!image) return;

    const gridCountDesktop = this.dataset.gridCountDesktop;
    const gridCountMobile = this.dataset.gridCountMobile;

    if (!gridCountDesktop && !gridCountMobile) return;

    const desiredWidth = this.isMobile() ? `calc(100vw / ${gridCountMobile})` : `calc(100vw / ${gridCountDesktop})`;
    const desiredHeight = `auto`;

    image.setAttribute('width', desiredWidth);
    image.setAttribute('height', desiredHeight);
  }

  updateCardPrice(element) {
    
    if (!element || !this.salePriceContainer || !this.regularPriceContainer) return;

    const variantPrice = element.dataset.variantPrice;
    const variantPriceValue = element.dataset.variantPriceValue;
    const variantComparePrice = element.dataset.variantCompareAtPrice;
    const variantComparePriceValue = element.dataset.variantCompareAtPriceValue;
    const salePriceEl = this.salePriceContainer.querySelector('.price--sale-price');
    const compareAtPriceEl = this.salePriceContainer.querySelector('.price--compare-at-price');
    const fromText = this.querySelectorAll('.price--from-text');

    if (fromText) fromText.forEach((text) => text.classList.add('hidden'));

    if (Number(variantComparePriceValue) > Number(variantPriceValue) && salePriceEl) {
      this.salePriceContainer.classList.remove('hidden');
      this.regularPriceContainer.classList.add('hidden');
      salePriceEl.textContent = variantPrice;
      compareAtPriceEl.textContent = variantComparePrice;
    } else {
      this.salePriceContainer.classList.add('hidden');
      this.regularPriceContainer.classList.remove('hidden');
      this.regularPriceContainer.textContent = variantPrice;
    }

  }

  isMobile = () => {
    return window.matchMedia('only screen and (max-width: 767px)').matches;
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

// Only define the custom element if it doesn't already exist
if (!customElements.get('product-card')) customElements.define('product-card', ProductCard);


};

if (window.T3SwiperRuntime?.Swiper) {
  __initWithSharedSwiper();
} else {
  window.addEventListener('t3:swiper-runtime:ready', __initWithSharedSwiper, { once: true });
}
/******/ })()
;
